<dropdown-action
  className="mx-2 d-print-none"
  *ngIf="(isShowComplete && viewEs) || isShowDuplicate || isShowDelete || isShowContactSupport || showPrint"
  [iconColor]="iconColor"
  [menuMode]="viewEs ? enumDropdownActionMenuMode.LIGHT : enumDropdownActionMenuMode.BLUE"
  [id]="'es-action-' + es.id"
  [ngClass]="{ 'show-in-list': showInList }"
>
  <button dropdown-item class="dropdown-item" (click)="printPage()" *ngIf="showPrint">
    {{ "BUTTON.PRINT_EXPORT_TO_PDF" | translate }}
  </button>
  <button dropdown-item class="dropdown-item" (click)="completeEs()" *ngIf="isShowComplete && viewEs">
    {{ completeText | translate }}
  </button>
  <button dropdown-item class="dropdown-item" (click)="goToChat()" *ngIf="showGoToChat && isShowGoToChat">
    {{ "BUTTON.OPEN_BROKER_MESSAGES" | translate }}
  </button>
  <button dropdown-item class="dropdown-item" (click)="contactToSupport()" *ngIf="isShowContactSupport">
    {{ "BUTTON.CONTACT_US" | translate }}
  </button>
  <button dropdown-item class="dropdown-item" (click)="duplicateEs()" *ngIf="isShowDuplicate">
    {{ "BUTTON.DUPLICATE" | translate }}
  </button>
  <button dropdown-item class="dropdown-item" (click)="goToDeliveryOrder()" *ngIf="showDelivery">
    {{ "BUTTON.CREATE_VIEW_DELIVERY" | translate }}
  </button>
  <button dropdown-item class="dropdown-item" (click)="openModal()" *ngIf="isShowDelete">
    {{ "BUTTON.DELETE" | translate }}
  </button>
</dropdown-action>

<custom-modal [(open)]="openDeleteModal" [header]="'LABELS.DELETE_ES'" [type]="'error'">
  <div>{{ "DELETE_PAID_ES" | translate }}</div>
  <button footer-action type="button" class="btn btn-primary" (click)="onDecline()">
    {{ "BUTTON.NO_KEEP_IT" | translate | uppercase }}
  </button>
  <button footer-action type="button" class="btn btn-secondary" (click)="delete()">
    {{ "BUTTON.YES_DELETE" | translate | uppercase }}
  </button>
</custom-modal>

<poa-required-modal [(open)]="showPoaRequiredModal" (discard)="onPoaModalDiscard()" (goToPoa)="onPoaModalGoToPoa()"></poa-required-modal>
